import React, { PureComponent } from 'react'
import { Table, Button,ModalHeader, ModalBody, ModalFooter, Col, Row } from 'reactstrap';
import Modal from '../../../components/UI/Modal/Modal';

const CLOSE = "CLOSE";
const SUBMIT = "SUBMIT";
const CANCEL = "CANCEL";
const PROCEED = "PROCEED";
class TableView extends PureComponent {
    state = {
        showModal: false,
        confirmModal: false,
        selectedCorporate:null
    };

    downloadFile = (e, id) => {
        e.preventDefault();
        this.props.downloadFile(id);
    }
    
    
    handleModalToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            warning: ""
        }))
    }
    handleSendMonitoringMail = (e, id) => {
        this.setState({confirmModal:!this.state.confirmModal,selectedCorporate:id})

    }
    handleConfirmModalButton = (type) => {
        if (type === PROCEED) {
            this.props.sendMonitoringEmail(this.state.selectedCorporate);
            this.setState({ confirmModal: !this.state.confirmModal });
        }else if(type=== CLOSE){
            this.setState({ confirmModal: !this.state.confirmModal });
        }
        
    }

    render() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Corporate Id</th>
                        <th>Corporate Name</th>
                    {/*     <th>Crawler Status</th> */}
                        <th>Monitoring Report</th>
                        <th>Send Email</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.monitoringCorporateData && this.props.monitoringCorporateData.length > 0 &&
                        this.props.monitoringCorporateData.map((obj, index) => <tr key={obj.corporateId}>
                           <th scope="row">{index}</th> 
                           <td>{obj.corporateId}</td>
                            <td>{obj.corporateName}</td>
                            <td><Button color='primary' onClick={(e) => this.downloadFile(e, obj.corporateId)}><i className="fa fa-download"></i></Button></td>
                            <td><Button color='primary' onClick={(e) => this.handleSendMonitoringMail(e, obj.corporateId)}><i className="fa fa-envelope-o"></i></Button></td>
                        </tr>)}
                </tbody>
                <Modal show={this.state.confirmModal} className="serveron-confirm-modal Large-Modal" >
                <ModalHeader>
                    Monitoring Mail 
                </ModalHeader>
                <ModalBody>
                    Are You Sure You Want to Send Mail ?
                </ModalBody>
                <ModalFooter>
                    <Col><Button color="success" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(PROCEED)}> Proceed </Button></Col>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(CLOSE)} > Cancel </Button></Col>
                </ModalFooter>
            </Modal>
            </Table>       
       )
      
    }
}

export default TableView
